/*
 *  I10DIAMPUISSI18n.js
 *
 *  Created by Sébastien Hecart on 2017-12-16 16:56:09 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

export default {
  I10DIAMPUISS_SECTION_0_TITLE: 'Trouvez le diamètre de tuyauterie nécessaire à votre installation',
  I10DIAMPUISS_material_uuid_mail: 'Type de tuyauterie',
  I10DIAMPUISS_in_puissance: 'Puissance',
  I10DIAMPUISS_in_delatTemp: 'Delta température',
  I10DIAMPUISS_in_vitesse: 'Vitesse',
  I10DIAMPUISS_viscosite_uuid_mail: "Température de l'eau",
  I10DIAMPUISS_res_debitReel: 'Débit',
  I10DIAMPUISS_SECTION_1_TITLE: '',
  I10DIAMPUISS_res_tube_uuid: 'Diamètre',
  I10DIAMPUISS_res_perteChargeResultat: 'Pertes de charges par m',
  I10DIAMPUISS_res_notfound: 'Tube non trouvé',
  I10DIAMPUISS_res_pdc: 'Pertes de charges en '
}
